import { motion } from "motion/react";
import type React from "react";
import { useTranslation } from "react-i18next";

const imgLogo = "/img/logo_word_color.svg";

export const WelcomeWaitingScreen: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="bg-white flex flex-col items-center justify-between min-h-screen p-6 relative w-full mx-auto overflow-hidden">
			{/* Logo */}
			<motion.div
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5 }}
				className="w-[109px] h-[24px] mt-6"
			>
				<img
					alt="inJOY Logo"
					className="w-full h-full object-contain"
					src={imgLogo}
				/>
			</motion.div>

			{/* Center Content */}
			<div className="flex flex-col items-center justify-center gap-5 text-center flex-1">
				<motion.div
					initial={{ opacity: 0, scale: 0.9 }}
					animate={{ opacity: 1, scale: 1 }}
					transition={{ duration: 0.5, delay: 0.2 }}
				>
					<h1 className="H2 text-color_text_grey_5 font-semibold mb-2 text-[48px] tracking-tight leading-tight">
						{t("guest.welcome.title")}
					</h1>
				</motion.div>
			</div>

			{/* Spacer for bottom balance */}
			<div className="h-[24px]"></div>
		</div>
	);
};
